export default [
  {
    field: 'col-opt',
    title: '操作',
    align: 'center',
    width: 170,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'originPlace',
    align: 'center',
    minWidth: 150,
    title: '始发地',
  },
  {
    field: 'destination',
    align: 'center',
    minWidth: 150,
    title: '目的地',
  },

  {
    field: 'lineTime',
    align: 'center',
    minWidth: 80,
    title: '时效',
  },

  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '整车价格',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '车辆类型',
  },

  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '车长',
  },
  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '载重',
  },
  {
    field: '',
    align: 'center',
    minWidth: 90,
    title: '载方',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '价格类型',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '费用设置',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '附加费',
  },
  {
    field: '',
    align: 'center',
    minWidth: 100,
    title: '扩展字段',
  },
]
